import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as semItineraryFragment } from './semItinerary';

export const SEM_ITINERARY_SEARCH_QUERY = gql`
  query semItinerarySearch(
    $semItinerariesSearchRequest: SemItinerariesSearchRequest!
  ) {
    semItinerarySearch(
      semItinerariesSearchRequest: $semItinerariesSearchRequest
    ) {
      priceTypeDisplayed {
        id
        name
      }
      itineraries {
        ...SemItineraryFragment
      }
    }
  }
  ${semItineraryFragment}
`;
